<template>
  <div class="logo-container">
    <div>Robusoft</div>
    <div>{{ vmpTitle }}</div>
    <!-- <img class="logo-text" src="@/assets/logo-text.png" alt=""> -->
  </div>
</template>

<script>
  export default {
    name: 'Logo',
    data() {
      return {
        vmpTitle: window.vmpTitle,
      }
    },
  }
</script>

<style lang='scss' scoped>
  .logo-container {
    width: 180px;
    color: var(--app-color-white);
    font-size: 18px;
    font-family: Poppins-SemiBold;
    // .logo-text {
    //   height: 85%;
    //   margin-bottom: 8px;
    // }

    text-align: center;
    div:first-child {
      font-size: 30px;
      font-weight: bold;
      line-height: 33px;
      transform: skewX(-16deg);
    }
    div:nth-child(2) {
      font-size: 16px;
      letter-spacing: 1px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/Logo.vue